import React, { useState } from 'react';
import { Tabs } from 'antd';
import { ApiOutlined, SettingOutlined, DatabaseOutlined, CreditCardOutlined } from '@ant-design/icons';
import PlatformSettings from './PlatformSettings';
import SystemConfigs from './SystemConfigs';
import DBBackupRestore from './DBBackupRestore';
import SubscriptionPlans from '../subscription_plans/subscription_plans';
import '../super-admin.css';

const PlatformSettingsPage = () => {
  const [activeTab, setActiveTab] = useState('api');

  const items = [
    {
      key: 'api',
      label: (
        <span>
          <ApiOutlined />
          API Management
        </span>
      ),
      children: <PlatformSettings />,
    },
    {
      key: 'system',
      label: (
        <span>
          <SettingOutlined />
          System Configs
        </span>
      ),
      children: <SystemConfigs />,
    },
    {
      key: 'backup',
      label: (
        <span>
          <DatabaseOutlined />
          DB Backup & Restore
        </span>
      ),
      children: <DBBackupRestore />,
    },
    {
      key: 'plans',
      label: (
        <span>
          <CreditCardOutlined />
          Subscription Plans
        </span>
      ),
      children: <SubscriptionPlans />,
    },
  ];

  return (
    <div className="sa-content">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
        style={{ marginBottom: 24 }}
      />
    </div>
  );
};

export default PlatformSettingsPage;
